export default __webpack_public_path__ + "static/media/Gold-01.6582adb4.png";